import { GetUsersQuery } from "@/generated/graphql";
import { MockUsers } from "@/repositories/mocks/graphql/query/constants";
import { graphql, HttpResponse } from "msw";

export const getUsersHandler = graphql.query<GetUsersQuery>(
  "getUsers",
  ({ query, variables }) => {
    return HttpResponse.json({
      data: {
        users: {
          users: MockUsers,
          pageInfo: {
            startCursor: "",
            endCursor: "",
            hasNextPage: false,
            hasPreviousPage: false,
          },
        },
      },
    });
  }
);
